import CommentLinkPreviews from '../../CommentLinkPreviews';
import LikeButton from '../../LikeButton';
import { extractUrlsFromText, isTextOnlyUrls } from '../../../utils/openGraphUtils';
import { plainTextForUrls } from '../utils/plainTextForUrls';
import { CommentRichText } from './CommentRichText';
import styles from '../CommentList.module.scss';

const layout = {
  comment: {
    rowInline: styles.commentRowInline,
    contentInline: styles.commentContentInline,
    row: styles.commentRow,
    textContainer: styles.commentTextContainer,
    contentRow: styles.commentContentRow,
    contentWrapper: styles.commentContentWrapper,
    actionWrapper: styles.commentActionWrapper,
  },
  reply: {
    rowInline: styles.replyRowInline,
    contentInline: styles.replyContentInline,
    row: styles.replyRow,
    textContainer: styles.replyTextContainer,
    contentRow: styles.replyContentRow,
    contentWrapper: styles.replyContentWrapper,
    actionWrapper: styles.replyActionWrapper,
  },
};

/**
 * Comment or reply body: text + likes + optional OpenGraph link previews.
 */
export function CommentMessageContent({
  variant,
  rawText,
  mentionedHandles,
  songId,
  comment,
  reply,
  currentUser,
  handleLike,
  handleUnlike,
  onMentionClick,
  commentIndex = null,
  replyIndex = null,
}) {
  const text = rawText || '';
  const plain = plainTextForUrls(text);
  const urls = extractUrlsFromText(plain);
  const hasOnlyUrls = urls.length > 0 && isTextOnlyUrls(plain);
  const hasOpenGraphData = urls.length > 0;
  const L = layout[variant];

  const likeTarget = reply ?? comment;
  const likeArgs = reply
    ? [songId, comment, currentUser?.uid, reply, commentIndex, replyIndex]
    : [songId, comment, currentUser?.uid, null, commentIndex, null];

  if (hasOnlyUrls && hasOpenGraphData) {
    return (
      <div className={L.rowInline}>
        <div className={L.contentInline}>
          <CommentLinkPreviews text={plain} />
        </div>
        <LikeButton
          isLiked={likeTarget.likes?.includes(currentUser?.uid)}
          onLike={() => handleLike(...likeArgs)}
          onUnlike={() => handleUnlike(...likeArgs)}
          likeCount={likeTarget.likes?.length || 0}
        />
      </div>
    );
  }

  return (
    <>
      <div className={L.row}>
        <div className={L.textContainer} onClick={onMentionClick}>
          {!hasOnlyUrls ? (
            <CommentRichText
              text={text}
              mentionedHandles={mentionedHandles}
            />
          ) : null}
        </div>
        <LikeButton
          isLiked={likeTarget.likes?.includes(currentUser?.uid)}
          onLike={() => handleLike(...likeArgs)}
          onUnlike={() => handleUnlike(...likeArgs)}
          likeCount={likeTarget.likes?.length || 0}
        />
      </div>
      {hasOpenGraphData && (
        <div className={L.contentRow}>
          <div className={L.contentWrapper}>
            <CommentLinkPreviews text={plain} />
          </div>
          <div className={L.actionWrapper} />
        </div>
      )}
    </>
  );
}
